import { styled } from 'goober';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)`
    display: contents;
`;
